import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { closeApp as closeAppAction, hideProgressStep as hideProgressStepAction } from '@redux/slices/workflowSlice'

type UseAppControlReturn = {
  closeApp: () => void
  hideProgressStep: () => void
}

export const useAppControl = (): UseAppControlReturn => {
  const dispatch = useDispatch()

  const closeApp = useCallback(() => {
    dispatch(closeAppAction())
  }, [dispatch])

  const hideProgressStep = useCallback(() => {
    dispatch(hideProgressStepAction())
  }, [dispatch])

  return {
    closeApp,
    hideProgressStep,
  }
}
